// extracted by mini-css-extract-plugin
export default {"select":"select-g_Ip4ElV"};